import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import locationGroupActions from 'actions/locationGroups'
import locationActions from 'actions/locations'
import assetCategoryActions from 'actions/assetCategories'
import assetActions from 'actions/assets'
import userActions from 'actions/users'
import Component from 'components/Reports/AssetRentalReport/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  locationGroups: selectors.locationGroups.selectOptions(state),
  locations: selectors.locations.selectOptions(state),
  assetCategories: selectors.assetCategories.selectOptions(state),
  assets: selectors.assets.selectOptions(state, { itemsOnly: false }),
  users: selectors.users.selectOptions(state),
})

const mapDispatchToProps = (dispatch, props) => ({
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) =>
    dispatch(locationActions.getOptions({ ...params, active: 'All', locationVendingTypes: ['NonVending'] })),
  getAssetCategories: (params) => dispatch(assetCategoryActions.getOptions(params)),
  getAssets: (params) =>
    dispatch(
      assetActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
      }),
    ),
  getUsers: (params) => dispatch(userActions.getOptions({ ...params, active: 'All' })),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
